import { Unsubscribe } from 'redux';
import actions from '../../../../store/actions';
import Modal from '../../../Common/Modal/Modal';
import React from 'react';
import store from '../../../../store/store';
import ChangeLog from '../../../Common/ChangeLog/ChangeLog';
import urlHelper from '../../../../infrastructure/helpers/common/urlHelper';
import httpClient from '../../../../infrastructure/helpers/common/httpClient';
import ComponentType from '../../../../types/report/ComponentType';
import { commonColumns } from '../../../Common/Modals/ChangeLogModal/ChangeLogModal.Grid';
import getColumns from './ComponentChangeLogModal.Grid';
import ComponentChangeLogModalState from './ComponentChangeLogModalState';
import ChangeDescription from '../../../../infrastructure/types/DifferenceVisualizer/ChangeDescription';
import { render } from 'react-dom';
import DiffModal from '../DiffModal/DiffModal';

interface State extends ComponentChangeLogModalState {
    showDownloadButton: boolean,
    showChangesDiffModal: boolean,
    leftLogic: string,
    rightLogic: string,
    diffPopupTitle: string
}
class ComponentChangeLogModal extends React.Component<any, State> {
    private unsubscribe: Unsubscribe | undefined;

    constructor(props: any) {
        super(props);

        this.state = {
            title: '',
            isOpen: false,
            error: null,
            id: 0,
            componentType: ComponentType.None,
            showDownloadButton: false,
            leftLogic: '',
            rightLogic: '',
            diffPopupTitle: '',
            showChangesDiffModal: false
        };

        this.onOpen = this.onOpen.bind(this);
        this.close = this.close.bind(this);
        this.onDownloadClick = this.onDownloadClick.bind(this);
        this.onRecordsFetched = this.onRecordsFetched.bind(this);
        this.onCompareChangesClick = this.onCompareChangesClick.bind(this);
    }

    componentDidMount(): void {
        this.unsubscribe = store.subscribe(this.onOpen);
    }

    componentWillUnmount(): void {
        (this.unsubscribe as Unsubscribe)();
    }

    onOpen(): void {
        let state = store.getState();

        if (state.action !== actions.componentChangeLogModal.open) {
            return;
        }

        this.setState(state.componentChangeLogModalState);
    }

    close(): void {
        this.setState({ isOpen: false, id: 0 });
    }

    onDownloadClick(): Promise<void> {
        let route = urlHelper.buildRoute(['component-version', this.state.id, this.state.componentType, 'export']);

        return httpClient.download(route, {});
    }

    onRecordsFetched(records: any) {
        if (records.length > 0) {
            this.setState({ showDownloadButton: true })
        }
    }


    onCompareChangesClick(change: ChangeDescription): void {
        this.setState({
            diffPopupTitle: `Differences for ${change.module} ${change.moduleName}`, showChangesDiffModal: true, leftLogic: change.previous, rightLogic: change.current
        });
    }

    render(): JSX.Element {

        return (
            <>
                <Modal state={this.state} close={this.close} size="large">
                    {this.state.showDownloadButton &&
                        <div className="mb-3 float-right">
                            <button className="btn cb-btn" onClick={this.onDownloadClick}>Download</button>
                        </div>
                    }
                    {
                        (this.state.componentType === ComponentType.MatchingKey.replace(/\s+/g, '') ||
                            this.state.componentType === ComponentType.MatchingKeyEndpoint.replace(/\s+/g, '') ||
                            this.state.id) &&
                        <ChangeLog
                            onRecordsFetched={this.onRecordsFetched}
                            hasWriteAccess={true}
                            getColumns={getColumns}
                            modalColumns={commonColumns((value: ChangeDescription) => this.onCompareChangesClick(value))}
                            backendRoute={urlHelper.buildRoute(['component-version', this.state.id, this.state.componentType])}
                            uniqueName={this.state.componentType} />
                    }

                </Modal>

                {
                    this.state.showChangesDiffModal &&
                    <DiffModal
                        left={this.state.leftLogic}
                        right={this.state.rightLogic}
                        title={this.state.diffPopupTitle}
                        onClose={() => this.setState({ showChangesDiffModal: false })}
                    />
                }
            </>
        );
    }
}

export default ComponentChangeLogModal;